(function () {
  function initCarousel(root) {
    if (root.__lm) return;
    root.__lm = true;
    var track = root.querySelector('[data-lm-track]');
    var prev = root.querySelector('[data-lm-prev]');
    var next = root.querySelector('[data-lm-next]');
    if (!track) return;
    var center = root.hasAttribute('data-lm-center');
    var items = Array.prototype.slice.call(track.querySelectorAll('.lm-cat'));

    function step() {
      var card = items[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : 320;
    }
    function markActive() {
      if (!center) return;
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
      var best = null, bd = Infinity;
      items.forEach(function (it) {
        var r = it.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = it; }
      });
      items.forEach(function (it) { it.classList.toggle('is-active', it === best); });
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      markActive();
    }
    var raf = 0;
    function onScroll() { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if (center && items.length) {
      var idx = Math.floor((items.length - 1) / 2);
      var it = items[idx];
      var left = it.offsetLeft + it.offsetWidth / 2 - track.clientWidth / 2;
      track.scrollTo({ left: left, behavior: 'instant' });
    }
    update();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lm-carousel]'), initCarousel);
  }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();